import { createAction, props } from '@ngrx/store';
import { IExperienceTemplate } from '../../models/experience-template.interface';

export const FetchExperienceTemplates = createAction('[Experience Template] Fetch Experience Templates');
export const FetchExperienceTemplatesSuccess = createAction('[Experience Template] Fetch Experience Templates Success', props<{ experienceTemplates: IExperienceTemplate[] }>());
export const FetchExperienceTemplatesFail = createAction('[Experience Template] Fetch Experience Templates Fail', props<{ errorMessage: any }>());
